import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurnDownLeftArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 12,
	viewBox: "0 0 15 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.7695 0.65625C12.7695 0.300781 13.043 0 13.4258 0C13.7812 0 14.082 0.300781 14.082 0.65625V5.25C14.082 6.58984 12.9883 7.65625 11.6758 7.65625H2.29688L4.67578 10.0352C4.94922 10.3086 4.94922 10.7188 4.67578 10.9648C4.42969 11.2383 4.01953 11.2383 3.77344 10.9648L0.273438 7.46484C0 7.21875 0 6.80859 0.273438 6.5625L3.77344 3.03516C4.01953 2.78906 4.42969 2.78906 4.67578 3.03516C4.94922 3.30859 4.94922 3.71875 4.67578 3.96484L2.29688 6.34375H11.6758C12.2773 6.34375 12.7695 5.85156 12.7695 5.25V0.65625Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgTurnDownLeftArrow);
export { ForwardRef as ReactComponent };
